import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import '../styles.less'
import ReviseContractStaff from '../../../widgets/revise/ReviseContractStaff'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import AgreementAdditional from '../../../widgets/agreementAdditional/AgreementAdditional'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { getSendEditContract } from '../../../redux/actions/contract'
import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'

export default function EditContractView() {
  //ขอแก้ไขข้อตกลงเพิ่มเติม
  const [isEditAll, setIsEditAll] = useState(false)
  const [showHead, setShowHead] = useState(true)
  const [showSubmit, setShowSubmit] = useState(false)
  const [schema, setSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isLoading, setIsLoading] = useState(false)
  const [section1, setSection1] = useState()
  const [error, setError] = useState()

  // const hindPanel = () => {
  //   setHideHead(true)
  //   setHideSubmit(false)
  // }

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  useEffect(() => {
    //console.log(schema)
    let selected = false
    schema?.forms?.projectFeedback?.revises?.forEach((element) => {
      element?.subItems?.forEach((item) => {
        if (item.selected) {
          selected = true
        }
      })
    })
    if (selected) {
      setShowSubmit(true)
      //console.log('setHideSubmit')
    } else {
      setShowSubmit(false)
    }
  }, [schema])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getSendEditContract(projectVersionId)

      if (
        response?.model?.forms?.requestNote?.sendToGrantee &&
        response?.model?.forms?.requestNote?.noteSendToGrantee?.value
      ) {
        response.model.forms.agreementDetails = {
          title: 'รายละเอียดสำหรับแก้ไข',
          content: response?.model?.forms?.requestNote?.noteSendToGrantee?.value || '',
          datetime: null,
          status: null,
        }
      }

      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  // const setNewState = (data) => {
  //   console.log('setNewState => ', data)
  //   setHideHead(data.hideHead_CallBack)
  //   setHideSubmit(data.hideSubmit_CallBack)
  //   setSection1(data.section1_CallBack)

  //   //schema.agreementAdditional.content = data.section1_CallBack
  //   setSchema(data.response_CallBack)
  // }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={6}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />

        {schema && (
          <>
            {showHead && schema?.forms?.agreementDetails && (
              <AgreementAdditionalWidgets
                showCommandButton={!schema.forms.agreementDetails.disabled}
                isEditAll={isEditAll}
                formSchema={schema.forms.agreementDetails}
              />
            )}

            {schema?.forms?.projectFeedback && (
              <ReviseContractStaff
                showCommandButton={!schema.forms.projectFeedback.disabled}
                isEditAll={isEditAll}
                schema={schema.forms.projectFeedback}
                onSuccess={(res) =>
                  setSchema((state) => ({
                    ...state,
                    forms: {
                      ...state.forms,
                      projectFeedback: res,
                    },
                  }))
                }
              />
            )}

            {showSubmit && schema?.forms?.requestNote?.note && (
              <AgreementAdditional
                showCommandButton={!schema.forms.requestNote.disabled}
                isEditAll={isEditAll}
                schema={schema.forms.requestNote}
                schemaAttachments={schema.forms.attachments}
                // hideHead={hideHead}
                // hideSubmit={hideSubmit}
                // section1={section1}
                // onCallBack={(e) => setNewState(e)}
                isEditContract={true}
              />
            )}

            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}
